export type Franchise = {
    id: string,
    name: string;
    status: FranchiseStatus;
    date_approved?: string;
    jobs_synced: string;
    listen360_location?: string;
}

export enum FranchiseStatus {
    Pending = "PENDING",
    Inactive = "INACTIVE",
    Active = "ACTIVE",
}
